import React, { useState } from 'react'
import Layout from '../../../../Components/Layout'
import Breadcrumb from '../../Component/Breadcrumb'
import Sidebar from '../../../Dashboard/Component/Siderbar'
import { useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios'
import Swal from 'sweetalert2'
import config from '../../../../config'

export default function Create() {
  const navigate = useNavigate();
  const location = useLocation();
  const agencyId = location.state.agencyId;
  const agencyName = location.state.agencyName;
  const [amount, setAmount] = useState("");
  const userData = JSON.parse(localStorage.getItem('user_data'));

  const handleSubmit = async (e) => {
    e.preventDefault(); // Formun varsayılan submit işlemini engeller

    try {
      const response = await axios.post(
        `${config.API_BASE_URL_V1}agency/add-balance-sub-agency`,
        {
          subAgencyId: agencyId,
          amount: amount, // Inputtaki amount değeri
        },
        {
          headers: {
            Authorization: `Bearer ${userData.token}`, // Bearer Token ile yetkilendirme
            "Content-Type": "application/json",
          },
        }
      );

      console.log("response: ",response)

      navigate('/dashboard-sub-agency-wallet-history', {state:{agencyId:agencyId}})
      Swal.fire({
        title: "Success!",
        text: `Balance added successfully! Amount: ${amount}`,
        icon: "success",
        confirmButtonText: "Ok",
      });

    } catch (error) {
      console.error("Hata oluştu:", error.response ? error.response.data : error);

      Swal.fire({
        title: "Insufficient Credit!",
        text: error.response?.data?.message || "Error while adding balance.",
        icon: "info",
        confirmButtonText: "Ok",
      });
    }
  };
  return (
    <Layout>
      <Breadcrumb title="Loading Credit" />
      <div className="content">
        <div className="container">
          <div className="row">
            <Sidebar>
              <div className="row">
                <div className="col-12">
                  <div className="card booking-header col-xl-12">
                    <div className="card-body header-content d-flex align-items-center justify-content-between flex-wrap" style={{ width:'100%' }}>
                      <div>
                        <h6 className="mb-1 text-capitalize"> {agencyName?.toLowerCase() ?? 'Update Balance'} </h6>
                      </div>
                    </div>
                  </div>

                  <form onSubmit={handleSubmit}>
                    <div className="card" id="basic_info">
                      <div className="card-body pb-1">
                        <div className="row" style={{ padding: "10px" }}>
                          <div className="col-md-7">
                            <div className="mb-3">
                              <div className="input-group">
                                <input
                                  type="number"
                                  className="form-control"
                                  name="amount"
                                  required
                                  placeholder="0.000"
                                  value={amount}
                                  onChange={(e) => setAmount(e.target.value)}
                                  style={{ borderRadius: '0.25rem 0 0 0.25rem' }}
                                />
                                <span className="input-group-text" style={{ borderRadius: '0 0.25rem 0.25rem 0' }}>EUR</span>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-5">
                            <button
                              type="submit"
                              className="btn btn-primary"
                              style={{
                                paddingInline: "80px",
                                borderRadius: '0.5rem',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                              }}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </Sidebar>
          </div>
        </div>
      </div>
    </Layout>
  )
}
